import { memo } from "react";
import { type PendingApproval } from "../../session-logic";

interface ComposerPendingApprovalPanelProps {
  approval: PendingApproval;
  pendingCount: number;
}

function formatWerkflowBody(body: unknown): string | null {
  if (body === undefined) return null;
  const json = JSON.stringify(body, null, 2);
  return json === undefined ? String(body) : json;
}

export const ComposerPendingApprovalPanel = memo(function ComposerPendingApprovalPanel({
  approval,
  pendingCount,
}: ComposerPendingApprovalPanelProps) {
  const werkflowRequest = approval.werkflowRequest;
  const approvalSummary =
    approval.title !== undefined
      ? werkflowRequest !== undefined
        ? approval.title
        : `ERP action approval requested: ${approval.title}`
      : approval.requestKind === "command"
        ? "Command approval requested"
        : approval.requestKind === "file-read"
          ? "File-read approval requested"
          : "File-change approval requested";
  const detailLabel =
    approval.requestKind === "command"
      ? "Command"
      : approval.requestKind === "file-read"
        ? "File to read"
        : "File change";

  return (
    <div className="px-4 py-3.5 sm:px-5 sm:py-4">
      <div className="flex flex-wrap items-center gap-2">
        <span className="uppercase text-sm tracking-[0.2em]">FREIGABE ERFORDERLICH</span>
        <span className="text-sm font-medium">{approvalSummary}</span>
        {pendingCount > 1 ? (
          <span className="text-xs text-muted-foreground">1/{pendingCount}</span>
        ) : null}
      </div>
      {werkflowRequest !== undefined ? (
        <details className="mt-2 rounded-md bg-foreground/5 px-3 py-2 text-xs text-muted-foreground">
          <summary className="cursor-pointer select-none font-medium text-muted-foreground">
            Technische Details anzeigen
          </summary>
          <div className="mt-2 space-y-2">
            <div className="font-mono">
              {werkflowRequest.method} {werkflowRequest.path}
            </div>
            {formatWerkflowBody(werkflowRequest.body) !== null ? (
              <pre className="max-h-56 overflow-auto whitespace-pre-wrap break-words font-mono">
                {formatWerkflowBody(werkflowRequest.body)}
              </pre>
            ) : (
              <div className="italic">Kein Anfrage-Text.</div>
            )}
          </div>
        </details>
      ) : approval.detail !== undefined && approval.detail.trim().length > 0 ? (
        <div className="mt-3 rounded-lg border border-border/65 bg-background/70 p-3">
          <p className="text-xs font-medium text-muted-foreground">{detailLabel}</p>
          <pre
            aria-label={detailLabel}
            className="mt-2 max-h-40 overflow-auto whitespace-pre-wrap break-words font-mono text-xs leading-relaxed text-foreground"
            data-approval-detail="complete"
          >
            {approval.detail}
          </pre>
        </div>
      ) : null}
    </div>
  );
});
